import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs';
import { FaseAtividadeFormComponent } from 'src/app/pages/fase-atividade-form/fase-atividade-form.component';
import { ModalCancelarComponent } from 'src/app/shared/components/modal-cancelar/modal-cancelar-component';

@Injectable()
export class FaseAtividadeGuard implements CanDeactivate<FaseAtividadeFormComponent> {
  canDeactivate(component: FaseAtividadeFormComponent): Observable<boolean> | boolean {
    if (component.novoRegistro) {
      if (component.submit) { return true; }
      return component.matDialog.open(ModalCancelarComponent).afterClosed();
    } else { return true; }
  }
}

